import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.435 2.704a1 1 0 0 0-.711-.038 14 14 0 0 0-5.135 2.969l-.085.088-.073.096a1 1 0 0 0-.169.573l.057 3.4-.057.088-.223.37-.209.377-.048.094-2.976 1.652-.103.066a1 1 0 0 0-.39.597 14 14 0 0 0 .005 5.932l.034.117.046.112a1 1 0 0 0 .412.432l2.974 1.65.047.095.209.377.222.37.057.088-.057 3.404.006.123a1 1 0 0 0 .322.635 14 14 0 0 0 5.14 2.962l.118.03.12.015a1 1 0 0 0 .58-.14l2.917-1.751.104.006.431.009.432-.008.105-.006 2.92 1.752.108.057a1 1 0 0 0 .712.038 14 14 0 0 0 5.134-2.97l.085-.087.074-.097a1 1 0 0 0 .168-.572l-.058-3.401.058-.088.223-.37.21-.377.045-.093 2.978-1.653.104-.066a1 1 0 0 0 .389-.597 14 14 0 0 0-.005-5.931l-.033-.118-.047-.112a1 1 0 0 0-.412-.432l-2.974-1.652-.047-.092-.208-.378-.223-.37-.058-.088.058-3.404-.005-.123a1 1 0 0 0-.323-.635 14 14 0 0 0-5.139-2.962l-.118-.03-.12-.015a1 1 0 0 0-.58.14l-2.917 1.75-.105-.005L16 4.498l-.431.008-.105.006-2.92-1.752zm-.843 2.132.32-.122 2.786 1.67.11.058a1 1 0 0 0 .478.083 9.5 9.5 0 0 1 1.424 0l.124.002.122-.013a1 1 0 0 0 .345-.128l2.781-1.67.325.121.409.17c.947.415 1.838.95 2.649 1.593l.265.218-.054 3.246.006.124a1 1 0 0 0 .167.456q.403.59.711 1.234l.06.108.073.099a1 1 0 0 0 .283.234l2.838 1.575.066.406.053.423c.107.99.09 1.99-.05 2.976l-.066.404-2.838 1.577-.104.066a1 1 0 0 0-.312.374 9.5 9.5 0 0 1-.713 1.232l-.063.107-.05.112a1 1 0 0 0-.061.362l.054 3.244-.266.22-.352.27a12 12 0 0 1-2.703 1.497l-.323.12-2.783-1.669-.11-.056a1 1 0 0 0-.479-.083q-.712.053-1.424-.002l-.123-.001-.123.013a1 1 0 0 0-.344.128l-2.784 1.669-.322-.12-.41-.17A12 12 0 0 1 8.537 25.4l-.267-.22.055-3.244-.005-.123a1 1 0 0 0-.168-.457 9.5 9.5 0 0 1-.71-1.234l-.061-.108-.073-.099a1 1 0 0 0-.283-.234l-2.839-1.576-.065-.405-.053-.423c-.107-.99-.09-1.99.051-2.976l.064-.405 2.84-1.576.104-.066a1 1 0 0 0 .311-.373q.31-.643.713-1.233l.063-.106.05-.113a1 1 0 0 0 .061-.362L8.27 6.822l.267-.22.352-.269a12 12 0 0 1 2.704-1.497M16 9a7 7 0 1 1 0 14 7 7 0 0 1 0-14m-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconGearSix = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconGearSix);
export default Memo;
